import { createApi } from "@reduxjs/toolkit/query/react";
import { api } from "../../../api/Api.jsx";

export const StudentDiscount = createApi({
    reducerPath: 'Discount',
    baseQuery: api,  
    tagTypes: ['Discounts'],
    endpoints: (build) => ({
        getStudentDiscount: build.query({
            query: (body) => `students/get_discount_students/?discount=true&author=true`,
            providesTags: ['tagTypes'],

        }),
        getStudentDiscountMonth: build.query({
            query: (body) => `student_discounts/get_months/`,
            providesTags: ['tagTypes'],

        }),
        addStudentDiscount: build.mutation({
            query: (body) => ({
                url: `student_discounts/`,
                method: "POST",
                body,
            }),
            invalidatesTags: ["tagTypes"],
        }),
    }),
});

export const {
    useGetStudentDiscountQuery,
    useAddStudentDiscountMutation,
    useGetStudentDiscountMonthQuery,
    

} = StudentDiscount;